import { createSlice } from "@reduxjs/toolkit";
import { BuscaConsignatarioModel } from "../../../models/consignatario/chamadas/buscaConsignatarioModel";
import { ConsignatarioModel } from "../../../models/consignatario/consignatarioModel";
import { buscarConsignatario } from "../../../services/consiganatarioService";
import { resetAll } from "../../actions/actions";

export interface ConsignatarioState {
  //buscar consignatario
  loading: boolean;
  busca: BuscaConsignatarioModel;
  list: ConsignatarioModel[];
  entity: ConsignatarioModel;
  //internal
  page: string;
  modalDadosUsuario: boolean;
  modalDeletar: boolean;
}

const initialState: ConsignatarioState = {
  //buscar consignatario
  loading: false,
  busca: {
    id: null,
    idUsuario: null,
    idEmpresa: null,
    pesquisar: null,
    ativo: null,
  } as BuscaConsignatarioModel,
  list: [],
  entity: {} as ConsignatarioModel,
  //internal
  page: "geral",
  modalDadosUsuario: false,
  modalDeletar: false,
};

export const consignatarioSlice = createSlice({
  name: "consignatario",
  initialState,
  reducers: {
    //buscar consignatario
    setBuscaConsignatario: (state, action) => {
      state.busca = action.payload;
    },
    setEntityConsignatario: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    setPageConsignatario: (state, action) => {
      state.page = action.payload;
    },
    setModalDadosUsuarioConsignatario: (state, action) => {
      state.modalDadosUsuario = action.payload;
    },
    setModalDeletarConsignatario: (state, action) => {
      state.modalDeletar = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar consignatario
    builder.addCase(buscarConsignatario.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarConsignatario.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarConsignatario.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar consignatario
  setBuscaConsignatario,
  setEntityConsignatario,
  //internal
  setPageConsignatario,
  setModalDadosUsuarioConsignatario,
  setModalDeletarConsignatario,
} = consignatarioSlice.actions;

export default consignatarioSlice.reducer;
